import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

const sizeToClass = (sizeClass?: string) => {
  switch (sizeClass) {
    case 'xs': return 'max-w-xs';
    case 'sm': return 'max-w-sm';
    case 'md': return 'max-w-md';
    case 'lg': return 'max-w-lg';
    case 'xl': return 'max-w-xl';
    case 'full': return 'max-w-[96vw]';
    default: return 'max-w-sm';
  }
};

type IModalProps = {
  show: boolean;
  children?: React.ReactNode;
  type: 'danger' | 'primary' | 'success';
  sizeClass?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
  onClose: () => void;
};

export const Modal = ({ show, children, onClose, sizeClass }: IModalProps) => {
  return (
    <Dialog open={show} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={cn('ux-modal-enter w-[calc(100vw-1.5rem)] sm:w-full max-h-[90vh] overflow-hidden border border-border/70 bg-background/95 p-0 gap-0 shadow-2xl', sizeToClass(sizeClass))}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;

// ModalDraggable — shadcn Dialog (draggable removed, same UX)
export const ModalDraggable = Modal;

export const ModalHeader = ({ title, onClose }: { title: string; classDragg?: boolean; onClose: () => void }) => {
  return (
    <DialogHeader className="border-b border-border/70 bg-muted/20 px-4 py-3 sm:px-6">
      <DialogTitle className="text-base font-semibold leading-6 sm:text-lg">{title}</DialogTitle>
    </DialogHeader>
  );
};

export const ModalBody = ({ children }: { children?: React.ReactNode }) => {
  return <div className="max-h-[calc(90vh-9.5rem)] overflow-y-auto px-4 py-4 sm:px-6">{children}</div>;
};

export const ModalFooter = ({ children }: { children?: React.ReactNode }) => {
  return <DialogFooter className="gap-2 border-t px-4 py-3 sm:px-6 [&>*]:w-full sm:[&>*]:w-auto">{children}</DialogFooter>;
};
